// services/participantes/estadosValidacionService.js
import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/estados-validacion`;

export async function getEstadosValidacion() {
  const response = await axios.get(baseUrl);
  return response.data;
}

export async function getSubestadosValidacion(estadoId) {
  // Validación para evitar NaN en la URL
  if (!estadoId || isNaN(estadoId)) {
    return { success: true, data: [] };
  }
  
  const response = await axios.get(`${baseUrl}/${estadoId}/subestados`);
  return response.data;
}